import { AxiosResponse } from 'axios';
import { action, computed, observable, makeObservable } from 'mobx';
import { PolicyTypeEnum } from '../classes/PolicyTypeEnum';
import FetchingService from './FetchingService';
import { PolicyScheduleAService } from './PolicyScheduleAService';
import { RootStore } from './RootStore';
import { clientUrls } from 'ui-toolkit/rest/ClientUrlFactory';
import { generatePolicyAsync } from './DocumentsServiceRequest';

interface IPolicyPreview {
  pageError: string;
}

export default class PolicyPreviewService {
  private policyScheduleA: PolicyScheduleAService | undefined = undefined;

  private loadPage = new FetchingService();

  private finalize = new FetchingService();

  private previewData: IPolicyPreview = {
    pageError: '',
  };

  constructor(rootStore: RootStore) {
    makeObservable<PolicyPreviewService, 'loadPage' | 'finalize' | 'previewData'>(this, {
      loadPage: observable,
      finalize: observable,
      previewData: observable,
      initPolicyPreview: action,
      setPageError: action,
      finalizeOrder: action,
      finalizeRequest: action,
      getPageErrorMessage: computed,
      getPageLoading: computed,
      getFinalizeInProcess: computed,
      getFinalizedSuccess: computed,
    });

    this.policyScheduleA = rootStore.policyScheduleAService;
  }

  public initPolicyPreview = async (policyCategory: PolicyTypeEnum, orderId: string) => {
    try {
      await this.policyScheduleA!.initPolicyScheduleAData(policyCategory, orderId);
      this.loadPage.fetchedSuccess();
    } catch (e: any) {
      this.setPageError(e);
      this.loadPage.fetchedError();
    }
  };

  public setPageError = (error: any) => {
    this.previewData.pageError = error;
  };

  public finalizeOrder = async (policyType: PolicyTypeEnum, orderId: string): Promise<void | AxiosResponse<any>> => {
    this.finalize.fetching();
    try {
      await this.finalizeRequest(policyType, orderId);
      this.finalize.fetchedSuccess();
      window.location.href = clientUrls.urlFor.title(orderId);
    } catch (error: any) {
      this.setPageError(error);
      this.finalize.fetchedError(error);
    }
  };

  public finalizeRequest = async (policyType: PolicyTypeEnum, orderId: string): Promise<void | AxiosResponse<any>> => {
    return generatePolicyAsync(policyType, orderId)
      .then(() => {
        return Promise.resolve();
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  };

  public get getPageErrorMessage(): string {
    return this.previewData.pageError;
  }

  public get getPageLoading(): boolean {
    return this.loadPage.getFetch.fetching!;
  }

  public get getFinalizeInProcess(): boolean {
    return this.finalize.getFetch.fetching!;
  }

  public get getFinalizedSuccess(): boolean {
    return this.finalize.getFetch.success!;
  }
}
